/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import { LanguageContext } from '../../../libs/Context';
import { LoginContext } from '../../../App';

const OngoingCallPopup = () =>
{
	const { language } = useContext(LanguageContext);
	const { socket, call, setCall } = useContext(LoginContext);

	const dialogPaperStyle = {
		backgroundColor : '#002532',
		color           : 'var(--whiteColor)'
	};

	const rejectCall = () =>
	{
		setCall({ status: false, type: null, callBy: null, roomId: null, roomUsers: null, roomType: null });
	};

	const onAccept = () =>
	{
		socket?.emit('accept_inc_call', { roomId: call?.roomId, from: true });
	};

	const acceptIncCall = useCallback(async (data) =>
	{
		if (call && data && call?.roomId === data?.roomId)
		{
			if (data?.roomType === 'group')
			{
				setCall({ ...call, reason: null, roomUsers: data?.roomUsers, inapi: data?.inapi });
			}
		}
	}, [ socket, call ]);

	useEffect(() =>
	{
		if (socket)
		{
			socket.on('accept_inc_call', acceptIncCall);
		}

		return () =>
		{
			socket && socket.off('accept_inc_call');
		};
	}, [ socket, call ]);

	return (
		<Dialog
			open
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
			PaperProps={{ style: dialogPaperStyle }}
		>
			<DialogTitle>
				{call?.type === 'audio' ? language?.OngoingAudioCallTitle : language?.OngoingVideoCallTitle}
			</DialogTitle>
			<DialogContent className=' pdngHSM'>
				<div className='flexRow whiteLTxt'>
					{call?.type === 'audio' ? language?.ongoingAudioCall : language?.ongoingVideoCall}
				</div>
			</DialogContent>
			<DialogActions>
				<div className='flexRow justifyCntr alignCntr brdrTWhiteL'>
					<button onKeyUp={(e) => { e.key === 'Enter' && rejectCall(); }} tabIndex={0} className='flexAutoCol pdngMD alignCntr justifyCntr' onClick={rejectCall}>
						<div className='flexInline callBtn endCallBtn alignCntr justifyCntr'>
							<CallEndIcon fontSize='large' className='whiteTxt' />
						</div>
						<span className='whiteLTxt pdngTXXS'>{language?.cancel}</span>
					</button>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && onAccept(); }} className='flexAutoCol pdngMD alignCntr justifyCntr' onClick={onAccept}>
						<div className='flexInline callBtn receiveBtn alignCntr justifyCntr'>
							<CallIcon fontSize='large' className='whiteTxt' />
						</div>
						<span className='whiteLTxt pdngTXXS'>{language?.join}</span>
					</button>
				</div>
			</DialogActions>
		</Dialog>
	);
};

export default OngoingCallPopup;